import React, {useEffect, useState, useRef, useCallback} from "react";
import {
    caMoveRepurposeCard,
    canMoveYtHelperCard,
    canAcceptYtHelperCard,
    canAcceptCard,
    canAcceptRepurposeCard,
    canMoveCard,
    isAdmin,
    isCustomer,
    resize,
    repurposingVideosName,
    S3_BUCKET,
    myBucket,
    isSubAdmin,
    isTeamLead,
    errorToast,
} from "../api/Util";
import { GOOGLE_DRIVE_LINK_ERROR_MESSAGE, isGoogleDriveLink, hasGoogleDriveLink } from "../helpers/commonHelper";
import {CANCELED, COMPLETED, DONE, EDITING, ON_HOLD, QA, REPURPOSE_QA, TEAM_LEAD, VIDEO_REQUEST, YT_HELPER_ASSINED, YT_HELPER_CANCELLED, YT_HELPER_IN_DONE, YT_HELPER_IN_PROGRESS} from "../api/Constants";
import {
    addCardTimeline,
    addRevision,
    decideTimeline,
    markAsDone,
    handleCardMarkAsCompleted,
    moveCard,
    moveCardSubStatus,
    updateSorting,
    moveYtHelperCardInDone,
    moveYtHelperCardInProgress,
    moveToQa,
    moveYtCard
} from "../api/CardActions";
import ConfirmationDialog from "./ConfirmationDialog";
import {Button, Checkbox, Col,Icon, Modal, TextInput} from "react-materialize";
import {connect} from 'react-redux';
import * as actions from "../actions";
import {
    DndContext,
    closestCenter,
    pointerWithin,
    PointerSensor,
    KeyboardSensor,
    useSensor,
    useSensors,
    DragOverlay,
    rectIntersection,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates, arrayMove } from '@dnd-kit/sortable';
import RequestCard from "./RequestCard";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { shouldProcessEditing } from "../helpers/commonHelper";

export const KanbanDndContext = React.createContext({
    activeId: null,
    overDroppableId: null,
    activeCardData: null,
    pendingMoves: {},
    dropPosition: null,
    pendingReorders: {},
});

function getCardList(cards) {
    if (!cards) return {};
    return cards.cardList || cards.ytHelperCardList || {};
}

function findSourceDroppableId(card, cards) {
    if (!card || !cards) return null;
    const cardId = String(card.card_id);
    const cardList = getCardList(cards);
    for (const [key, cardArray] of Object.entries(cardList)) {
        if (!Array.isArray(cardArray)) continue;
        const found = cardArray.find((c) => String(c.card_id) === cardId);
        if (found) {
            const mainKeyToDroppable = {
                video_requests: 'video_request|none|none',
                on_hold: 'on_hold|none|none',
                editing: 'editing|none|none',
                qa_cards: 'qa|none|none',
                done_cards: 'done|none|none',
                cancelled_cards: 'canceled|none|none',
                repurposeEditing: 'none|editing|none',
                repurposeQA: 'none|repurposeQA|none',
                repurposeDone: 'none|done|none',
                updatedDone: 'Completed|none|none',
            };
            if (mainKeyToDroppable[key]) return mainKeyToDroppable[key];
            const ytKeyToDroppable = {
                assigne_card: 'none|none|assignedCard',
                inProgress: 'none|none|inProgress',
                inDone: 'none|none|inDone',
                cancelled: 'none|none|cancelled',
            };
            if (ytKeyToDroppable[key]) return ytKeyToDroppable[key];
        }
    }
    return null;
}

function parseDroppableId(droppableId) {
    if (!droppableId) return { type: null, rType: null, ytType: null };
    const [type, rType, ytType] = droppableId.split('|');
    return {
        type: type === 'none' ? null : type,
        rType: rType === 'none' ? null : rType,
        ytType: ytType === 'none' ? null : ytType,
    };
}

function isRepurposeColumn(parsedDroppable = {}) {
    return !!parsedDroppable?.rType;
}

export default connect(mapStateToProps, actions)(({loggedInUser, refresh, setKey, subDomain, cards, children}) => {
    const repurposingVideosCount = subDomain.subDomainData.repurposing_videos_count;
    const [selectedFile, setSelectedFile] = useState(null);
    const [reviewCard, setReviewCard] = useState({ open: false });
    const [addTimeline, setAddTimeline] = useState({ open: false });
    const [confirmation, setConfirmation] = useState({ open: false });
    const [confirmationCardToDone, setConfirmationCardToDone] = useState({ open: false });
    const [confirmationCardToCompleted, setConfirmationCardToCompleted] = useState({ open: false });
    const [confirmationRepurpose, setConfirmationRepurpose] = useState({ open: false });
    const [doneLink, setDoneLink] = useState({ open: false });
    const [doneLinkUrl, setDoneLinkUrl] = useState("");
    const [doneLinkUrlArray, setDoneLinkUrlArray] = useState([]);
    const [repurposeDoneLink, setRepurposeDoneLink] = useState({ open: false });
    const [unlistedLink, setUnlistedLink] = useState("");

    // for yt helper dashboard card movement 
    const [moveCardInProgress, setMoveCardInProgress] = useState({open:false});
    const [ytHelperAssetsModal, setYtHelperAssetsModal] = useState({open:false});

    const [thumbnailsLink, setThumbnailsLink] = useState("");
    const [snippetLink, setSnippetLink] = useState("");
    const [videoDescription, setVideoDescriptions] = useState("");
    const [editorState, setEditorState] = useState();
    const [disableButton, setDisableButton] = useState(true);

    const [confirmationYtCard, setConfirmationYtCard] = useState({open:false});

    const [contentID, setContentID] = useState("");
    const [requiredContentId, setRequiredContentId] = useState(true);

    const [confirmToQA, setConfirmToQA] = useState({open:false});
    const [confirmToQAFromDone, setConfirmToQAFromDone] = useState({open:false});

    const [activeId, setActiveId] = useState(null);
    const [overDroppableId, setOverDroppableId] = useState(null);
    const [activeCardData, setActiveCardData] = useState(null);
    const [pendingMoves, setPendingMoves] = useState({});
    const [dropPosition, setDropPosition] = useState(null);
    const [pendingReorders, setPendingReorders] = useState({});
    const dragStateRef = useRef(null);
    const columnListsRef = useRef({});
    const lastDropPositionRef = useRef(null);

    const registerColumnList = useCallback((droppableId, list) => {
        columnListsRef.current[droppableId] = list;
    }, []);
    const getColumnList = useCallback((droppableId) => {
        return columnListsRef.current[droppableId];
    }, []);

    const addPendingMove = (cardId, targetDroppableId, cardData) => {
        setPendingMoves(prev => ({ ...prev, [cardId]: { targetDroppableId, cardData } }));
    };
    const removePendingMove = (cardId) => {
        setPendingMoves(prev => {
            const next = { ...prev };
            delete next[cardId];
            return next;
        });
    };
    const revertCardPosition = (cardId) => {
        if (cardId) removePendingMove(cardId);
        dragStateRef.current = null;
    };
    const moveCardSafe = (cardId, target, source, onSuccess) => {
        moveCard(cardId, target, source, () => {
            if (onSuccess) onSuccess();
            dragStateRef.current = null;
        });
    };
    const moveCardSubStatusSafe = (cardId, target, source, onSuccess, opts = {}) => {
        moveCardSubStatus(cardId, target, source, () => {
            if (onSuccess) onSuccess();
            dragStateRef.current = null;
        }, opts);
    };

    const sensors = useSensors(
        useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
        useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
    );
    const collisionDetection = useCallback((args) => {
        const pointerCollisions = pointerWithin(args);
        if (pointerCollisions?.length) return pointerCollisions;
        return closestCenter(args);
    }, []);

    const handleDragStart = useCallback((event) => {
        const cardId = String(event.active.id);
        setActiveId(cardId);
        setOverDroppableId(null);
        setDropPosition(null);
        const data = event.active.data?.current;
        let fullCard = data?.card;
        if (!fullCard) {
            fullCard = cards?.cardMap?.[cardId] || cards?.cardMap?.[Number(cardId)];
        }
        if (!fullCard && cards) {
            const cardList = getCardList(cards);
            for (const cardArray of Object.values(cardList)) {
                if (Array.isArray(cardArray)) {
                    const found = cardArray.find(c => String(c.card_id) === cardId);
                    if (found) { fullCard = found; break; }
                }
            }
        }
        if (!fullCard) { setActiveId(null); return; }
        const cardStatus = fullCard.card_status;
        const canMove = fullCard.repurpose_status
            ? caMoveRepurposeCard(loggedInUser, fullCard.repurpose_status)
            : fullCard.ytHelper_card_status
                ? canMoveYtHelperCard(loggedInUser, fullCard.ytHelper_card_status)
                : canMoveCard(loggedInUser, cardStatus || 'editing', Number(fullCard.paused) || 0, Number(fullCard.is_complete) || 0);
        if (!canMove) { setActiveId(null); return; }
        const sourceDroppableId = data?.sortable?.containerId || findSourceDroppableId(fullCard, cards);
        dragStateRef.current = { cardId, sourceDroppableId, cardData: { ...fullCard } };
        setActiveCardData(fullCard);
    }, [cards, loggedInUser]);

    const handleDragOver = useCallback((event) => {
        const { active, over } = event;
        if (!over) {
            lastDropPositionRef.current = null;
            setOverDroppableId(null);
            setDropPosition(null);
            return;
        }
        const sortableData = over.data?.current?.sortable;
        const droppableId = (sortableData?.containerId) || over.id;
        const columnKeyMap = {
            'video_request': 'video_requests', 'on_hold': 'on_hold', 'editing': 'editing', 'qa': 'qa_cards',
            'done': 'done_cards', 'canceled': 'cancelled_cards', 'repurpose_qa': 'repurposeQA', 'Completed': 'updatedDone',
            'assignedCard': 'assigne_card', 'inProgress': 'inProgress', 'inDone': 'inDone', 'cancelled': 'cancelled',
        };
        const parsed = parseDroppableId(droppableId);
        let columnKey = parsed.ytType ? (columnKeyMap[parsed.ytType] || parsed.ytType) : (parsed.rType ? (parsed.rType === 'editing' ? 'repurposeEditing' : parsed.rType === 'done' ? 'repurposeDone' : 'repurposeQA') : columnKeyMap[parsed.type]);
        const cardList = getCardList(cards);
        const registeredList = getColumnList(droppableId);
        const columnCards = Array.isArray(registeredList) ? registeredList : (columnKey && cardList[columnKey] ? cardList[columnKey] : []);
        const activeCardId = String(active.id);
        const displayCards = columnCards.filter(c => String(c.card_id) !== activeCardId);
        let index = displayCards.length;
        if (sortableData?.containerId) {
            const overCardId = String(over.id);
            const idx = displayCards.findIndex(c => String(c.card_id) === overCardId);
            if (idx !== -1) index = idx;
        }
        const next = { columnId: droppableId, index };
        if (lastDropPositionRef.current?.columnId === next.columnId && lastDropPositionRef.current?.index === next.index) {
            return;
        }
        lastDropPositionRef.current = next;
        setOverDroppableId(droppableId);
        setDropPosition(next);
    }, [cards, getColumnList]);

    const handleDragEnd = useCallback((event) => {
        const { active, over } = event;
        const cardId = String(active?.id);
        setActiveId(null);
        setOverDroppableId(null);
        setActiveCardData(null);
        setDropPosition(null);
        if (!over || !dragStateRef.current) {
            dragStateRef.current = null;
            return;
        }
        const admin = isAdmin(loggedInUser);
        const customer = isCustomer(loggedInUser);
        const subAdmin = isSubAdmin(loggedInUser);
        const teamLead = isTeamLead(loggedInUser);
        let fullCard = cards?.cardMap?.[cardId] || cards?.cardMap?.[Number(cardId)] || dragStateRef.current?.cardData;
        if (!fullCard) { dragStateRef.current = null; return; }
        const sortableData = over.data?.current?.sortable;
        const targetDroppableId = sortableData?.containerId || over.id;
        const sourceDroppableId = dragStateRef.current.sourceDroppableId;
        if (!sourceDroppableId || !targetDroppableId) { dragStateRef.current = null; return; }
        const sourceParsed = parseDroppableId(sourceDroppableId);
        const targetParsed = parseDroppableId(targetDroppableId);
        let targetStatus = targetParsed.type;
        let sourceStatus = sourceParsed.type;
        let targetSubStatus = targetParsed.rType;
        let sourceSubStatus = sourceParsed.rType;
        let ytHelperSourceStatus = sourceParsed.ytType || fullCard.ytHelper_card_status;
        let ytHelperTargetStatus = targetParsed.ytType;
        const contentId = fullCard.content_id || "";
        const is_complete = fullCard.is_complete;
        const revisions = fullCard.revision_nr ? fullCard.revision_nr : 0;
        const doneVideoLimit = fullCard?.done_video_limit ? fullCard.done_video_limit : "1";

        if (sourceDroppableId === targetDroppableId) {
            if ((admin || customer) && targetStatus === VIDEO_REQUEST) {
                const columnKey = "video_requests";
                const cardList = getCardList(cards);
                const registeredList = getColumnList(sourceDroppableId);
                const columnCards = (Array.isArray(registeredList) && registeredList.length > 0) ? registeredList : (cardList[columnKey] || []);
                const currentOrder = columnCards.map(c => String(c.card_id));
                const activeIndex = currentOrder.indexOf(cardId);
                const overId = String(over.id);
                const overIndex = currentOrder.indexOf(overId);
                let newOrder = null;
                if (activeIndex !== -1 && overIndex !== -1 && activeIndex !== overIndex) {
                    const toIndex = activeIndex < overIndex ? overIndex - 1 : overIndex;
                    newOrder = arrayMove(currentOrder, activeIndex, toIndex);
                } else if (activeIndex !== -1 && overId === sourceDroppableId) {
                    const lastIndex = currentOrder.length - 1;
                    if (activeIndex !== lastIndex) {
                        newOrder = arrayMove(currentOrder, activeIndex, lastIndex);
                    }
                }
                if (newOrder && newOrder.length > 0) {
                    setPendingReorders(prev => ({ ...prev, [columnKey]: newOrder.map(id => Number(id)) }));
                    updateSorting(newOrder.map((id, i) => ({ card_id: Number(id), sort: i + 1 }))).catch(() => {
                        setPendingReorders(prev => { const n = { ...prev }; delete n[columnKey]; return n; });
                    });
                }
            }
            dragStateRef.current = null;
            return;
        }

        if (targetStatus === COMPLETED) {
            const repurposeStatus = sourceSubStatus || fullCard.repurpose_status;
            const isRepurposeEnabled = fullCard.repurpose_aspect === 1 || fullCard.repurpose_aspect === '1' || fullCard.repurpose_aspect === true;
            let completedCardStatus = null;
            if (!(admin || subAdmin || teamLead)) {
                errorToast("You don't have permission to move this card to that column.");
            } else if (repurposeStatus === DONE) {
                completedCardStatus = "repurposeDone";
            } else if (sourceSubStatus) {
                errorToast("The Card is in progress, So we cannot mark it as completed");
            } else if (sourceStatus !== DONE) {
                errorToast("Card Is Not in Done");
            } else if (isRepurposeEnabled) {
                errorToast("Cannot mark card as completed, as this card has repurpose enabled");
            } else {
                completedCardStatus = DONE;
            }
            if (completedCardStatus) {
                addPendingMove(cardId, targetDroppableId, { ...fullCard });
                setConfirmationCardToCompleted({ open: true, cardId, cardStatus: completedCardStatus });
            } else {
                revertCardPosition(cardId);
            }
            dragStateRef.current = null;
            return;
        }

        if (sourceStatus === COMPLETED && !admin) {
            revertCardPosition(cardId);
            errorToast("You don't have permission to move this card to that column.");
            return;
        }

        const isRepurposeMove = isRepurposeColumn(sourceParsed) || isRepurposeColumn(targetParsed);
        const canAccept = isRepurposeMove
            ? (canAcceptRepurposeCard(loggedInUser, sourceSubStatus, targetSubStatus) || canAcceptCard(loggedInUser, sourceStatus, targetStatus))
            : fullCard.ytHelper_card_status || ytHelperTargetStatus || ytHelperSourceStatus
                ? canAcceptYtHelperCard(loggedInUser, fullCard.ytHelper_card_status || ytHelperSourceStatus, ytHelperTargetStatus)
                : canAcceptCard(loggedInUser, sourceStatus, targetStatus);
        if (!canAccept) {
            revertCardPosition(cardId);
            errorToast("You don't have permission to move this card to that column.");
            return;
        }
        addPendingMove(cardId, targetDroppableId, { ...fullCard });

        let flag = false;
        const sourceColumnType = sourceSubStatus ? (sourceSubStatus === 'editing' ? 'repurpose_editing' : sourceSubStatus === 'done' ? 'repurpose_done' : sourceSubStatus) : sourceStatus;
        const targetColumnType = targetSubStatus ? (targetSubStatus === 'editing' ? 'repurpose_editing' : targetSubStatus === 'done' ? 'repurpose_done' : targetSubStatus) : targetStatus;

        if (isRepurposeMove && targetStatus !== QA) {
            if (admin && (!(targetSubStatus && sourceSubStatus) && !(targetStatus && sourceStatus) && !(targetSubStatus && sourceStatus))) {
                flag = true;
                let finalTargetSubStatus = targetSubStatus;
                switch (targetStatus) {
                    case VIDEO_REQUEST: finalTargetSubStatus = "video_request"; break;
                    case ON_HOLD: finalTargetSubStatus = "on_hold"; break;
                    case EDITING: finalTargetSubStatus = "normalEditing"; break;
                    case QA: finalTargetSubStatus = "normalQA"; break;
                    case DONE: finalTargetSubStatus = "normalDone"; break;
                    default: break;
                }
                switch (finalTargetSubStatus) {
                    case EDITING: finalTargetSubStatus = "repurposing"; break;
                    case DONE: finalTargetSubStatus = "repurposeDone"; break;
                    case REPURPOSE_QA: finalTargetSubStatus = REPURPOSE_QA; break;
                    default: break;
                }
                let finalSourceSubStatus = sourceSubStatus;
                if (sourceSubStatus === "editing") finalSourceSubStatus = "repurposing";
                else if (sourceSubStatus === "done") finalSourceSubStatus = "repurposeDone";
                else if (sourceSubStatus === REPURPOSE_QA) finalSourceSubStatus = REPURPOSE_QA;
                let finalSourceStatus = sourceStatus;
                if (sourceStatus === "editing") finalSourceStatus = "normalEditing";
                else if (sourceStatus === "done") finalSourceStatus = "normalDone";
                else if (sourceStatus === "qa") finalSourceStatus = "normalQA";
                setConfirmation({ open: true, cardId, newStatus: finalTargetSubStatus, cardStatus: finalSourceSubStatus || finalSourceStatus });
                dragStateRef.current = null;
                return;
            }
            const state = { open: true, cardId, newStatus: targetSubStatus, cardStatus: sourceSubStatus || sourceStatus, sourceColumnType, targetColumnType };
            if ((targetSubStatus === DONE) || (targetSubStatus === REPURPOSE_QA)) {
                setRepurposeDoneLink(state);
            } else {
                setConfirmationRepurpose(state);
            }
            dragStateRef.current = null;
            return;
        }

        if (ytHelperSourceStatus || ytHelperTargetStatus) {
            const state = { open: true, cardId, newStatus: ytHelperTargetStatus, cardStatus: ytHelperSourceStatus };
            if (ytHelperTargetStatus === YT_HELPER_IN_PROGRESS) setMoveCardInProgress(state);
            else if (ytHelperTargetStatus === YT_HELPER_IN_DONE) setYtHelperAssetsModal(state);
            else if (ytHelperTargetStatus === YT_HELPER_CANCELLED) setConfirmationYtCard(state);
            else if (ytHelperTargetStatus === YT_HELPER_ASSINED && ytHelperSourceStatus === YT_HELPER_CANCELLED) setConfirmationYtCard(state);
            dragStateRef.current = null;
            return;
        }

        if (admin || customer) {
            if (customer && targetStatus === CANCELED) {
                setConfirmation({ open: true, cardId, newStatus: targetStatus, cardStatus: sourceStatus });
            } else if (admin && targetStatus === DONE && sourceStatus === ON_HOLD) {
                setConfirmationCardToDone({ open: true, cardId, newStatus: targetStatus, cardStatus: sourceStatus });
            }
        }

        if (!customer && !flag) {
            switch (targetStatus) {
                case VIDEO_REQUEST:
                    if (sourceStatus !== targetStatus && (is_complete !== 1 && is_complete !== '1' || admin)) setReviewCard({ open: true, cardId, cardStatus: sourceStatus });
                    break;
                case EDITING:
                    if (shouldProcessEditing(admin, subAdmin, is_complete, sourceStatus)) setAddTimeline({ open: true, cardId, cardStatus: sourceStatus, timeline: decideTimeline(revisions) });
                    break;
                case ON_HOLD:
                case CANCELED:
                    if (sourceStatus !== targetStatus && (is_complete !== 1 && is_complete !== '1' || admin)) setConfirmation({ open: true, cardId, newStatus: targetStatus, cardStatus: sourceStatus });
                    break;
                case DONE:
                    if ((is_complete !== 1 && is_complete !== '1' || admin) && sourceStatus !== ON_HOLD) setDoneLink({ open: true, cardId, contentId, newStatus: DONE, cardStatus: sourceStatus, revisions, doneVideoLimit: parseInt(doneVideoLimit, 10) });
                    break;
                case QA:
                    if (is_complete !== 1 && is_complete !== '1' || admin) {
                        if (sourceStatus === DONE) setConfirmToQAFromDone({ open: true, cardId, newStatus: QA, cardStatus: sourceStatus, doneVideoLimit: parseInt(doneVideoLimit, 10) });
                        else setConfirmToQA({ open: true, cardId, contentId, newStatus: QA, cardStatus: sourceStatus, doneVideoLimit: parseInt(doneVideoLimit, 10) });
                    }
                    break;
                default:
                    break;
            }
        }
        dragStateRef.current = null;
    }, [loggedInUser, cards]);

    useEffect(() => {
        setActiveId(null);
        setOverDroppableId(null);
        setActiveCardData(null);
        setDropPosition(null);
        setPendingMoves({});
        setPendingReorders({});
        dragStateRef.current = null;
        lastDropPositionRef.current = null;
    }, [cards?.cardList]);

    useEffect(() => {
        if (!cards?.cardMap || Object.keys(pendingMoves).length === 0) return;
        const toRemove = Object.keys(pendingMoves).filter((cardId) => {
            const card = cards.cardMap[cardId] || cards.cardMap[Number(cardId)];
            if (!card) return false;
            const pending = pendingMoves[cardId];
            const [tType, tRType, tYtType] = pending.targetDroppableId.split('|');
            const match = (tType === 'none' || tType === (card.card_status || 'none')) &&
                (tRType === 'none' || tRType === (card.repurpose_status || 'none')) &&
                (tYtType === 'none' || tYtType === (card.ytHelper_card_status || 'none'));
            return match;
        });
        if (toRemove.length > 0) {
            setTimeout(() => toRemove.forEach((id) => removePendingMove(id)), 300);
        }
    }, [cards?.cardMap]);

    useEffect(() => {
        if (!cards?.cardList?.video_requests || Object.keys(pendingReorders).length === 0) return;
        const timeoutId = setTimeout(() => {
            setPendingReorders((prev) => {
                const next = { ...prev };
                delete next.video_requests;
                return next;
            });
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [cards?.cardList?.video_requests]);

    function handleEditorStateChange(e){
        if(e)
        {
            // Converting editor state to html 
            let value = draftToHtml(convertToRaw(e.getCurrentContent()));
            // Storing the editor state to display in the model
            setEditorState(e);
            // Storing the editor html tag in state so that it can be pass to backend
            setVideoDescriptions(value);
        }
    }

    function isValidURL(string) {
         // eslint-disable-next-line no-useless-escape
        var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return (res !== null)
    };

    /**
     * To save done url
     * @param {int} value 
     * @param {int} index 
     */
     function handleChangeDoneURL(value, index, name, fieldName) {
        if (fieldName === 'repurposingFields') {
            setDoneLinkUrlArray((prev) => ({
                ...prev,
                [index]: { type: name, url: value },
              }));
        } else {
            if(index != null && index >= 0) {
                let list = doneLinkUrlArray;
                list = resize(list, index, "");
                list[index] = value;
                setDoneLinkUrlArray(list);
            }
        }
    }
    const doneLinkUrlAndTypeArray = Object.entries(doneLinkUrlArray).map((e) => (e[1]));
    /**
     * To map the fields in modal
     * @param {int} limit 
     * @returns array of fields
     */
    function mapDoneVideoFields(limit, fieldName) {
        let tempFields = [];
        for(let i = 0; i<limit; i++) {
            tempFields.push(
                fieldName === "repurposingFields" ? (
                  <>
                    <TextInput
                      s={12}
                      name={repurposingVideosName[i]}
                      label={repurposingVideosName[i]}
                      icon="link"
                      validate
                      key={"qa-done-link" + i}
                      value={doneLinkUrlArray[i]?.url || ""}
                      onChange={(e) =>
                        handleChangeDoneURL(e.target.value, i, e.target.name, 'repurposingFields')
                      }
                    />
                    {isGoogleDriveLink(doneLinkUrlArray[i]?.url) && (
                      <span className="red-text">{GOOGLE_DRIVE_LINK_ERROR_MESSAGE}</span>
                    )}
                  </>
                ) : (
                  <>
                    <TextInput
                      s={12}
                      label={"Video Link"}
                      icon="link"
                      validate
                      key={"qa-done-link" + i}
                      value={doneLinkUrlArray[i] || ""}
                      onChange={(e) => handleChangeDoneURL(e.target.value, i)}
                    />
                    {isGoogleDriveLink(doneLinkUrlArray[i]) && (
                      <span className="red-text">{GOOGLE_DRIVE_LINK_ERROR_MESSAGE}</span>
                    )}
                  </>
                )
              );
        }
        return tempFields;
    }

    useEffect(() => {
        let data = doneLinkUrlAndTypeArray.find(item => item?.url)
            if(doneLinkUrlAndTypeArray.length > 0 && data?.url !== undefined) {
                setDisableButton(false);
            } else {
                setDisableButton(true);
            }
    }, [doneLinkUrlAndTypeArray])

    const onChangeFile = (e) => {
        let value = e.target.files[0];

        const params = {
            ACL: 'public-read',
            Body: value,
            Bucket: S3_BUCKET,
            Key: 'prod/media/srt/'+value.name
        };
        myBucket.upload(params,
            (err, data) => {
            if (err) {
                return err;
            } else {
                let temp = data?.Key ? "https://videoportal-files.s3.amazonaws.com/"+ data.Key : null;
                setSelectedFile(temp);
            }
        })
    }

    function onChangeContentIdCheck () {
        setRequiredContentId(!requiredContentId);
        setContentID("");
    }

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={collisionDetection}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
            onDragCancel={() => {
                setActiveId(null);
                setOverDroppableId(null);
                setActiveCardData(null);
                setDropPosition(null);
                dragStateRef.current = null;
            }}
        >
        <KanbanDndContext.Provider value={{ activeId, overDroppableId, activeCardData, pendingMoves, dropPosition, pendingReorders, registerColumnList, getColumnList }}>
        <div>
            <ConfirmationDialog
                onNegative ={()=> {revertCardPosition(moveCardInProgress.cardId); setMoveCardInProgress({open:false}); setKey(k=>k+1);}}
                onPositive ={()=> {moveYtHelperCardInProgress(moveCardInProgress.cardId, moveCardInProgress.newStatus,moveCardInProgress.cardStatus,()=>{dragStateRef.current=null;refresh()})}}
                confirmationHeader = "Confirm"
                confirmationDialogId = {"confirm-ythelper-card-move"}
                confirmation = {moveCardInProgress.open}
                confirmationText = {"Are you sure you want to move the card for editing section"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(reviewCard.cardId); setReviewCard({ open: false }); setKey(k => k+1);}}
                onPositive={() => addRevision(reviewCard.cardId, reviewCard.cardStatus, () => { dragStateRef.current = null; refresh(); })}
                confirmationHeader="Revision"
                confirmationDialogId="confirm-revision"
                confirmation={reviewCard.open}
                confirmationText={"Are you sure you want to request revision?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(addTimeline.cardId); setAddTimeline({ open: false }); setKey(k => k+1);}}
                onPositive={() => addCardTimeline(addTimeline.cardId, addTimeline.cardStatus, addTimeline.timeline, () => { dragStateRef.current = null; refresh(); })}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-timeline"}
                confirmation={addTimeline.open}
                confirmationText={"Confirm move card to editing?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(confirmationCardToDone.cardId); setConfirmationCardToDone({open: false}); setKey(k => k+1);}}
                onPositive={() => markAsDone(confirmationCardToDone.cardId, confirmationCardToDone.cardStatus, "", () => { dragStateRef.current = null; refresh(); }, "", [])}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-move"}
                confirmation={confirmationCardToDone.open}
                confirmationText={"Are you sure you want to move the card to done?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(confirmationCardToCompleted.cardId); setConfirmationCardToCompleted({open: false}); setKey(k => k+1);}}
                onPositive={async () => {
                    const { cardId, cardStatus } = confirmationCardToCompleted;
                    const isSuccessful = await handleCardMarkAsCompleted({ cardId, cardStatus });
                    dragStateRef.current = null;
                    if (isSuccessful) refresh();
                    else revertCardPosition(cardId);
                }}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-move-for-completed-card"}
                confirmation={confirmationCardToCompleted.open}
                confirmationText={"Are you sure you want to mark card as completed?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(confirmation.cardId); setConfirmation({open: false}); setKey(k => k+1);}}
                onPositive={() => moveCardSafe(confirmation.cardId, confirmation.newStatus, confirmation.cardStatus, refresh)}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-move"}
                confirmation={confirmation.open}
                confirmationText={"Are you sure you want to move the card?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(confirmationYtCard.cardId); setConfirmationYtCard({open: false}); setKey(k => k+1);}}
                onPositive={() => moveYtCard(confirmationYtCard.cardId, confirmationYtCard.newStatus, confirmationYtCard.cardStatus, () => { dragStateRef.current = null; refresh(); })}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-move"}
                confirmation={confirmationYtCard.open}
                confirmationText={"Are you sure you want to move the card?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(confirmToQAFromDone.cardId); setConfirmToQAFromDone({open: false}); setKey(k => k+1);}}
                onPositive={() => moveCardSafe(confirmToQAFromDone.cardId, confirmToQAFromDone.newStatus, confirmToQAFromDone.cardStatus, refresh)}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-move"}
                confirmation={confirmToQAFromDone.open}
                confirmationText={"Are you sure you want to move the card?"}
            />
            <ConfirmationDialog
                onNegative={() => {revertCardPosition(confirmationRepurpose.cardId); setConfirmationRepurpose({open: false}); setKey(k => k+1);}}
                onPositive={() => moveCardSubStatusSafe(
                    confirmationRepurpose.cardId,
                    confirmationRepurpose.newStatus,
                    confirmationRepurpose.cardStatus,
                    () => refresh(),
                    { targetColumnType: confirmationRepurpose.targetColumnType, sourceColumnType: confirmationRepurpose.sourceColumnType }
                )}
                confirmationHeader="Confirm"
                confirmationDialogId={"confirm-move-sub"}
                confirmation={confirmationRepurpose.open}
                confirmationText={"Are you sure you want to move the card to repurposing?"}
            />
            <Modal
                actions={[
                    <Button flat modal="close" node="button" waves="red" large onClick={() => { if (doneLink.cardId) revertCardPosition(doneLink.cardId); setDoneLink({ open: false }); setKey(k => k + 1); }}>Close</Button>,
                    <Button modal="close" onClick={() => markAsDone(doneLink.cardId, doneLink.cardStatus, doneLinkUrl, refresh, contentID,doneLinkUrlArray)}
                            disabled={doneLinkUrl
                                && !hasGoogleDriveLink(doneLinkUrl, doneLinkUrlArray)
                                && ((requiredContentId && contentID !== "") || !requiredContentId)
                                ? false
                                : true } node="button" waves="green" large>Submit</Button>
                ]}
                header="Set video link and sync id for music"
                id="setVideoLinkModal"
                open={doneLink.open}
                // style={{height: '35rem'}}
                options={{
                    dismissible: true,
                    endingTop: '10%',
                    opacity: 0.5,
                    preventScrolling: true,
                    onOpenStart: () => {setDoneLinkUrl(""); setContentID("");setDoneLinkUrlArray([]); setRequiredContentId(true)},
                    onCloseEnd: () => {if (doneLink.cardId) revertCardPosition(doneLink.cardId); setDoneLink({open: false}); setKey(k => k+1);}
                }}
            >
                <TextInput s={12} label="Video Link" icon="link" validate id={"txt-done-link"}
                           value={doneLinkUrl} onChange={e => setDoneLinkUrl(e.target.value)}/>
                {isGoogleDriveLink(doneLinkUrl) && (
                    <span className="red-text">{GOOGLE_DRIVE_LINK_ERROR_MESSAGE}</span>
                )}
                {
                     mapDoneVideoFields(4)
                }
                
                <TextInput s={12} label={ doneLink.revisions > 0 ? "Any Additional Sync ID (Optional)" : "Sync ID for Music Licensing" } icon="short_text" id={"txt-content-id"}
                           value={contentID || doneLink.contentId} onChange={e => setContentID(e.target.value)} disabled={!requiredContentId} />
                <Checkbox
                    id="contentIdRequired"
                    label="Please remove the checkmark If order has no Sync ID"
                    onChange={onChangeContentIdCheck}
                    checked={requiredContentId}
                    />
            </Modal>
            <Modal
                actions={[
                    <Button flat modal="close" node="button" waves="red" large onClick={() => { if (repurposeDoneLink.cardId) revertCardPosition(repurposeDoneLink.cardId); setRepurposeDoneLink({ open: false }); setKey(k => k + 1); const el = document.getElementById('srt-input'); if (el) el.value = null; }}>Close</Button>,
                    <Button
                        modal="close"
                        onClick={() =>
                            moveCardSubStatus(
                                repurposeDoneLink.cardId,
                                repurposeDoneLink.newStatus,
                                repurposeDoneLink.cardStatus,
                                refresh,
                                {
                                    sourceColumnType: repurposeDoneLink.sourceColumnType,
                                    targetColumnType: repurposeDoneLink.targetColumnType,
                                    additionalData: {
                                        done_link: doneLinkUrlArray[0],
                                        doneLinkUrlArray: doneLinkUrlAndTypeArray.slice(1)
                                    },
                                    selectedFile
                                }
                            )
                        }
                        disabled={
                            hasGoogleDriveLink("", doneLinkUrlAndTypeArray)
                            || (repurposeDoneLink.newStatus !== DONE && disableButton)
                        }
                        node="button"
                        waves="green"
                        large
                    >
                        Submit
                    </Button>
                ]}
                header="Set repurposed video link"
                id="setReVideoLinkModal"
                open={repurposeDoneLink.open}
                // style={{height: '20rem'}}
                options={{
                    dismissible: true,
                    endingTop: '10%',
                    opacity: 0.5,
                    preventScrolling: true,
                    onOpenStart: () => { setDoneLinkUrl(""); setDoneLinkUrlArray({}); document.getElementById('srt-input').value = null;},
                    onCloseEnd: () => {if (repurposeDoneLink.cardId) revertCardPosition(repurposeDoneLink.cardId); setRepurposeDoneLink({open: false}); setKey(k => k+1); document.getElementById('srt-input').value = null;}
                }}
            >
                {
                    mapDoneVideoFields(repurposingVideosCount, 'repurposingFields')
                }
               <div style={{ display: "flex" }}>
                <Icon style={{ marginRight: "18px", marginTop: "4px" }}>
                    attach_file
                </Icon>
                <input
                    style={{ width: "100%" }}
                    className="custom-file-input"
                    s={12}
                    id="srt-input"
                    type="file"
                    name="srtFile"
                    onChange={(e) => onChangeFile(e)}
                    label="Select SRT File"
                />
            </div>
            </Modal>
            <Modal
                actions = {[
                    <Button flat modal='close' node='button' waves="red" large onClick={() => { if (ytHelperAssetsModal.cardId) revertCardPosition(ytHelperAssetsModal.cardId); setYtHelperAssetsModal({ open: false }); setKey(k => k + 1); }}>Close</Button>,
                    <Button modal="close" onClick={()=> moveYtHelperCardInDone(ytHelperAssetsModal.cardId,
                        ytHelperAssetsModal.newStatus,ytHelperAssetsModal.cardStatus,thumbnailsLink,videoDescription,snippetLink,unlistedLink,refresh
                        )} disabled={! (isValidURL(thumbnailsLink) && (videoDescription !== "<p></p>")) } node="button" waves = "green" large>Submit</Button>
                ]}
                header = "Set YouTube Helper Assets"
                id="setYtHelperAssetsModel"
                open = {ytHelperAssetsModal.open}
                style={{height: '50rem'}}
                options={{
                    dismissible: true,
                    endingTop: '10%',
                    opacity: 0.5,
                    preventScrolling: true,
                    onOpenStart: () => {setThumbnailsLink(""); setSnippetLink(""); setUnlistedLink(""); setVideoDescriptions("");setEditorState();},
                    onCloseEnd: () => {if (ytHelperAssetsModal.cardId) revertCardPosition(ytHelperAssetsModal.cardId); setYtHelperAssetsModal({open: false}); setKey(k => k+1);}
                }}
            >
                <TextInput s={12} label="Video Thumbnail Link" icon="link" validate id={"thumbnails-link"}
                           value={thumbnailsLink} onChange={e => setThumbnailsLink(e.target.value)}/>

                {(isAdmin(loggedInUser) || loggedInUser.client_type === TEAM_LEAD || loggedInUser.client_type === QA) ? <TextInput s={12} label="Snippet Link" icon="link" validate id={"snippet-link"}
                           value={snippetLink} onChange={e => setSnippetLink(e.target.value)}/> : null}

                <TextInput s={12} label="Unlisted Video" icon="link" validate id={"unlisted-link"}
                           value={unlistedLink} onChange={e => setUnlistedLink(e.target.value)}/>
                
                <Col s={12} className="label-column">
                <label>Video Description</label>
                </Col>
                <Col s={12} className="label-column labele_title">
                    <Icon>short_text</Icon>
                    <Editor
                        toolbar = {{options: ['inline', 'blockType', 'fontSize', 'list', 'colorPicker', 'emoji']}}
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={(e)=>{handleEditorStateChange(e)}}
                    />
                    <div className="clearfix"></div>
                </Col>
                
            </Modal>
            <Modal
                actions={[
                    <Button flat modal="close" node="button" waves="red" large onClick={() => { if (confirmToQA.cardId) revertCardPosition(confirmToQA.cardId); setConfirmToQA({ open: false }); setKey(k => k + 1); }}>Close</Button>,
                    <Button modal="close" onClick={() => moveToQa(confirmToQA.cardId, confirmToQA.cardStatus, doneLinkUrl, refresh, contentID, doneLinkUrlArray)}
                            disabled={isValidURL(doneLinkUrl)
                                && !hasGoogleDriveLink(doneLinkUrl, doneLinkUrlArray)
                                && ((requiredContentId && contentID !== "") || !requiredContentId)
                                ? false
                                : true } node="button" waves="green" large>Submit</Button>
                ]}
                header="Set video link and sync id for music"
                id="setQAVideoLinkModal"
                open={confirmToQA.open}
                // style={{height: '30rem'}}
                options={{
                    dismissible: true,
                    endingTop: '10%',
                    opacity: 0.5,
                    preventScrolling: true,
                    onOpenStart: () => {setDoneLinkUrl(""); setContentID(""); setDoneLinkUrlArray([]); setRequiredContentId(true)},
                    onCloseEnd: () => {if (confirmToQA.cardId) revertCardPosition(confirmToQA.cardId); setConfirmToQA({open: false}); setKey(k => k+1);}
                }}
            >
                <TextInput s={12} label="Video Link" icon="link" validate id={"qa-done-link"}
                           value={doneLinkUrl} onChange={e => setDoneLinkUrl(e.target.value)}/>
                {isGoogleDriveLink(doneLinkUrl) && (
                    <span className="red-text">{GOOGLE_DRIVE_LINK_ERROR_MESSAGE}</span>
                )}
                {
                    confirmToQA?.doneVideoLimit > 1 ? mapDoneVideoFields(confirmToQA?.doneVideoLimit) : null
                }
                <TextInput s={12} label={ doneLink.revisions > 0 ? "Any Additional Sync ID (Optional)" : "Sync ID for Music Licensing" } icon="short_text" id={"txt-content-id"}
                        value={contentID || confirmToQA.contentId} onChange={e => setContentID(e.target.value)} disabled={!requiredContentId} />
                <Checkbox
                    id="contentIdRequired"
                    label="Please remove the checkmark If order has no Sync ID"
                    onChange={onChangeContentIdCheck}
                    checked={requiredContentId}
                    />
            </Modal>
            {children}
        </div>
        <DragOverlay>
            {activeCardData ? (
                <div style={{ pointerEvents: 'none' }}>
                    <RequestCard
                        setCardActivityModal={() => {}}
                        setCardActivityData={() => {}}
                        viewCard={() => {}}
                        card={activeCardData}
                        section=""
                        setCardRepurposeModal={() => {}}
                        setCurrentCardId={() => {}}
                        currentCardRepurpose={true}
                        SetCardYtHelperEnableModal={() => {}}
                        CardYtHelperEnableModal={false}
                        setCurrentCardData={() => {}}
                        updatedYtHelperStatus={false}
                    />
                </div>
            ) : null}
        </DragOverlay>
        </KanbanDndContext.Provider>
        </DndContext>
    );
});

function mapStateToProps({subDomain}) {
    return {subDomain};
}
